var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","hide-details":"","items":_vm.items,"dense":"","append-icon":"","menu-props":"auto"},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }